import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import PortfolioSection from "./components/PortfolioSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import CTABanner from "./components/CTABanner";
import ServicePage from "./pages/ServicePage";
import SoftwareDevelopmentPage from "./pages/SoftwareDevelopmentPage";
import SEO from "./components/SEO";
import ScrollToHash from "./components/ScrollToHash";

const HomePage = () => {
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Infinity Solutions Hub',
    description: 'Marketing agency and custom software development in Las Vegas, NV.',
    telephone: '702-605-7282',
    email: 'Info@infinitysolutionshub.com',
    url: 'https://infinitysolutionshub.com/',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Las Vegas',
      addressRegion: 'NV',
      addressCountry: 'US',
    },
    areaServed: 'US',
    priceRange: '$$',
  };

  return (
    <>
      <SEO
        title="Infinity Solutions Hub | Marketing & Software Agency in Las Vegas"
        description="One-stop shop for web, software, blockchain, social media, SEO, PPC and branding. Design, develop and deliver tailored software that scales. Call 702-605-7282 for 20% OFF!"
        canonical="https://infinitysolutionshub.com/"
        jsonLd={homeJsonLd}
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <CTABanner variant="phone" />
        <PortfolioSection />
        <CTABanner variant="consultation" />
        <TestimonialsSection />
        <CTABanner />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#151515',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
            },
          }}
        />
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/software-development" element={<SoftwareDevelopmentPage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
